import type { ReactNode } from 'react';
import { VerticalStack } from '../../../alignment/vertical-stack';
import { DEFAULT_HEADING_LEVEL_3_TYPOGRAPHY } from '../../../typography';
import { DiffedReadonlyList } from '../diffed/diffed-readonly-list';
import type { ReadonlyListItem } from '../item/readonly-list-item';
import type { ReadonlyListGroup, ReadonlyListStackProps } from './readonly-list-stack';

export interface DiffedReadonlyListGroup extends ReadonlyListGroup {
  changeItems: ReadonlyListItem[] | undefined;
}

export interface DiffedReadonlyListStackProps extends Omit<ReadonlyListStackProps, 'groups'> {
  changeLabel: ReactNode;
  groups: DiffedReadonlyListGroup[];
}

export function DiffedReadonlyListStack({
  changeLabel,
  defaultLinkElement = 'a',
  gap = 7,
  groups,
  isPending,
  titleGap = gap,
  titleTypography = DEFAULT_HEADING_LEVEL_3_TYPOGRAPHY,
  ...props
}: DiffedReadonlyListStackProps) {
  return (
    <VerticalStack gap={gap} {...props}>
      {groups.map((group) => (
        <DiffedReadonlyList
          changeItems={group.changeItems}
          changeLabel={changeLabel}
          defaultLinkElement={defaultLinkElement}
          id={group.id}
          isPending={isPending}
          items={group.items}
          key={group.id}
          title={group.title}
          titleGap={group.titleGap || titleGap}
          titleTypography={group.titleTypography || titleTypography}
        />
      ))}
    </VerticalStack>
  );
}
